import React, {useState} from "react";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Title from "../../components/Title";
import Body from "../../layout/Body";
import { default as Button } from "../../../../components/common/button/Button";
import PresetTable from "./components/PresetTable";
// import SamplePresetData from "./components/SamplePresetData";
import { ADD_ROOM_PERMISSIONS, CACHE_QUERY_OPTIONS, DEFAULT_QUERY_OPTIONS } from "../../../../constants";
import { getAllRoomPreset } from "../../../../api/ClientsTagController";
import RoomPresetModal from "./components/RoomPresetModal";
import Modal from "../../components/Modal";

const RoomPreset = () => {
    const [isModalAddOpen, setIsModalAddOpen] = useState(false);

    const {
        data: roomPresetsData,
        isLoading: roomPresetsLoading,
    } = useQuery(
        ["roomPresets"], // Query key, add params if needed
        () => getAllRoomPreset(), // Query function
        {
            ...DEFAULT_QUERY_OPTIONS(),
        }
    );

    return (
        <>
            <CardTable>
                <TableRow>
                    <Title
                        title={"Room Presets"}
                        description={
                            "Manage all room presets in Intraverse. Changes made here are automatically pushed to related environments."
                        }
                    />
                    <TableColumn>
                        <Button
                            variant={"OutlinedButton"}
                            // disabled={successMessageBanner !== ""}
                            label={"Create Room Preset"}
                            margin={"2rem 0 0 0"}
                            onClick={
                                // () => navigate("/console/room_preset/create")
                                () => setIsModalAddOpen(true)
                            }
                        />
                    </TableColumn>
                </TableRow>
            </CardTable>
            <Body isLoading={roomPresetsLoading}>
                <PresetTable presetData={roomPresetsData?.roomPresets || []} />
            </Body>

            {isModalAddOpen && (
                <Modal
                    isOpen={isModalAddOpen}
                    setIsOpen={setIsModalAddOpen}
                    children={<RoomPresetModal closeModal={() => setIsModalAddOpen(false)} />}
                />
            )}
        </>
    );
};

export default RoomPreset;

const CardTable = styled.div`
    display: flex;
    flex-direction: column;
`;

const TableRow = styled.div`
    display: flex;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const TableColumn = styled.div`
    flex: 1;
    @media (max-width: 768px) {
        font-size: 14px;
    }
`;
